import React from 'react'
import ReactDOM from 'react-dom'
import camelcaseKeys from 'camelcase-keys'

import Entry from '../components/glossary_entries/components/Entry'

document.addEventListener('DOMContentLoaded', () => {
  const elem = document.getElementById('glossary_entry');
  const data = camelcaseKeys(JSON.parse(elem.getAttribute('data')), { deep: true })

  ReactDOM.render(
    <Entry
      name={data.name}
      description={data.description}
      categoryName={data.categoryName}
      relatedEntries={data.relatedEntries}
      similarEntries={data.similarEntries}
      links={data.links}
      linkLabels={data.linkLabels}
    />,
    elem
  );
}, { once: true });
